import Vue from 'vue'
import VueRouter from 'vue-router'

// 设备检测模块
const detectDevice = () => {
    const userAgent = window.navigator.userAgent.toLowerCase()
    return /mobile|android|iphone/i.test(userAgent)
}

Vue.use(VueRouter)

const routes = [
    /*桌面端*/
    {
        path:'/',
        redirect:'/index'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('../views/IndexView.vue')
    },
    {
        path: '/product',
        name: 'product',
        component: () => import('../views/ProductExampleView.vue'),
    },
    {
        path: '/productExample',
        name: 'productExample',
        component: () => import('../views/ProductExampleView.vue'),
    },
    {
        path: '/product/productId/:productId',
        name: 'productDetails',
        component: () => import("../views/ProductViewDetail.vue")
    },
    {
        path: '/example',
        name: 'example',
        component: () => import('../views/ExampleView.vue')
    },
    {
        path: '/example/exampleId/:exampleId',
        name: 'exampleDetails',
        component: () => import('../views/ExampleDetailsView.vue')
    },
    {
        path: '/contactUs',
        name: 'contactUs',
        component: () => import('../views/ContactUs.vue')
    },
    {
        path: '/apply',
        name: 'apply',
        component: () => import('../views/Apply.vue')
    },
    {
        path: '/productIndex',
        name: 'productIndex',
        component: () => import('../views/ProductIndexView.vue')
    },
    {
        path: '/productFileDetail/productId/:productId',
        name: 'productFileDetail',
        component: () => import("../views/productFileDetail.vue")
    },
    {
        path: '/newsIndex',
        name: 'newsIndex',
        component: () => import('../views/NewsIndex.vue')
    },
    {
        path: '/news',
        name: 'news',
        component: () => import('../views/NewsView.vue')
    },
    {
        path: '/news/newsId/:newsId',
        name: 'newsDetails',
        component: () => import('../views/NewsDetailsView.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/AboutView.vue')
    },
    {
        path: '/aboutIndex',
        name: 'aboutIndex',
        component: () => import('../views/AboutIndex.vue')
    },
    {
        path: '/webSiteSearchView/title/:title',
        name: 'webSiteSearchView',
        component: () => import("../views/WebSiteSearchView.vue")
    },
    /*手机端*/
    {
        path:'/mobile',
        redirect:'/mobile/index'
    },
    {
        path: '/mobile/index',
        name: 'mobileIndex',
        component: () => import('../views/mobile/IndexView.vue'),
        meta: {
            showFooter: false // 默认不显示页脚
        }

    },
    {
        path: '/mobile/product',
        name: 'mobileProduct',
        component: () => import('../views/mobile/ProductExampleView.vue'),
    },
    {
        path: '/mobile/productExample',
        name: 'mobileProductExample',
        component: () => import('../views/mobile/ProductExampleView.vue'),
    },
    {
        path: '/mobile/product/productId/:productId',
        name: 'mobileProductDetails',
        component: () => import("../views/mobile/ProductViewDetail.vue")
    },
    {
        path: '/mobile/example',
        name: 'mobileExample',
        component: () => import('../views/mobile/ExampleView.vue')
    },
    {
        path: '/mobile/example/exampleId/:exampleId',
        name: 'mobileExampleDetails',
        component: () => import('../views/mobile/ExampleDetailsView.vue')
    },
    {
        path: '/mobile/contactUs',
        name: 'mobileContactUs',
        component: () => import('../views/mobile/ContactUs.vue')
    },
    {
        path: '/mobile/apply',
        name: 'mobileApply',
        component: () => import('../views/mobile/Apply.vue')
    },
    {
        path: '/mobile/productIndex',
        name: 'mobileProductIndex',
        component: () => import('../views/mobile/ProductIndexView.vue')
    },
    {
        path: '/mobile/productFileDetail/productId/:productId',
        name: 'mobileProductFileDetail',
        component: () => import("../views/mobile/productFileDetail.vue")
    },
    {
        path: '/mobile/newsIndex',
        name: 'mobileNewsIndex',
        component: () => import('../views/mobile/NewsIndex.vue')
    },
    {
        path: '/mobile/news',
        name: 'mobileNews',
        component: () => import('../views/mobile/NewsView.vue')
    },
    {
        path: '/mobile/news/newsId/:newsId',
        name: 'mobileNewsDetails',
        component: () => import('../views/mobile/NewsDetailsView.vue')
    },
    {
        path: '/mobile/about',
        name: 'mobileAbout',
        component: () => import('../views/mobile/AboutView.vue')
    },
    {
        path: '/mobile/aboutIndex',
        name: 'mobileAboutIndex',
        component: () => import('../views/mobile/AboutIndex.vue')
    },
    {
        path: '/mobile/webSiteSearchView/title/:title',
        name: 'mobileWebSiteSearchView',
        component: () => import("../views/mobile/WebSiteSearchView.vue")
    }
]

const router = new VueRouter({
    routes
})

// 全局导航守卫
router.beforeEach((to, from, next) => {
    const isMobile = detectDevice()
    const isMobilePath = to.path.startsWith('/mobile')

    if (isMobile && !isMobilePath) {
        next(`/mobile${to.path}`)
    } else if (!isMobile && isMobilePath) {
        // 桌面设备访问移动端路由 → 跳转到对应桌面路由
        next(to.path.replace('/mobile', ''))
    } else {
        next()
    }
})

// 全局导航守卫 - 修复哈希模式问题
router.beforeEach((to, from, next) => {
    const isMobile = detectDevice();
    // 正确识别移动端路由，无论是否是哈希模式
    const isMobilePath = to.path.startsWith('/mobile/') || to.path === '/mobile';

    // 移动设备访问非移动端路由
    if (isMobile && !isMobilePath) {
        next({
            path: `/mobile${to.path}`,
            replace: true // 替换历史记录，避免回退问题
        });
    }
    // 桌面设备访问移动端路由
    else if (!isMobile && isMobilePath) {
        // 移除路径中的/mobile部分
        const desktopPath = to.path.replace(/^\/mobile/, '') || '/';
        next({
            path: desktopPath,
            replace: true // 替换历史记录
        });
    }
    // 设备与路由匹配，正常跳转
    else {
        next();
    }
});

export default router
